// Angular
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

// Afidium
import { SashaPageComponent } from '../sasha-page.component';
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { ViewsService } from 'libraries/view/views.service';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { wenji } from 'libraries/interfaces/IWenji';
import { TitleService } from 'app_sasha/shared/services/title/title.service';

@Component({
    selector: 'booking',
    template: `
        <div class="app-wrapper app-sasha">
            <div class="inactive-breadcrumb">
                <div class="item">{{ labels.booking }}</div>
            </div>
            <booking-main></booking-main>
        </div>
    `
})

export class BookingComponent extends SashaPageComponent implements OnInit {
    public labels: ILabels = {
        booking: Yii.t('wui-sasha-js', 'Dossier')
    };

    constructor(
        protected views: ViewsService,
        readonly appRootService: AppRootService,
        private readonly titleService: TitleService
    ) {
        super(views, appRootService);
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.titleService.setTitle(Yii.t("wui-sasha-js", "Dossiers"));
    }
}